import { render } from "./offersModal.vue?vue&type=template&id=587d72aa&ts=true"
import script from "./offersModal.vue?vue&type=script&lang=ts"
export * from "./offersModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__